import { useCallback, useMemo } from 'react'
import { useUserRole } from '@/contexts/UserRoleContext'
import { hasPermission } from '@/config/routes.config'
import { getDefaultRedirectPath } from '@/utils/helper'

export function useRBAC() {
  const { currentRole, currentUser } = useUserRole()

  const userRole = useMemo(() => {
    return currentRole?.name || undefined
  }, [currentRole])

  const isLoading = useMemo(() => {
    return currentUser === null || currentRole === null
  }, [currentUser, currentRole])

  const canAccess = useCallback(
    (path: string): boolean => {
      if (!userRole) return false
      return hasPermission(userRole, path)
    },
    [userRole]
  )

  const getDefaultPath = useCallback(() => {
    return getDefaultRedirectPath()
  }, [])

  return {
    isLoading,
    canAccess,
    getDefaultPath,
  }
}
